export const PhoneIcon = ({ width = 16, height = 17, fill = 'none' }) => {
    return (
        <svg width={width} height={height} fill={fill} viewBox='0 0 16 17' xmlns='http://www.w3.org/2000/svg'>
            <path d='M4.41333 7.69333C5.37333 9.58 6.92 11.12 8.80667 12.0867L10.2733 10.62C10.4533 10.44 10.72 10.38 10.9533 10.46C11.7 10.7067 12.5067 10.84 13.3333 10.84C13.7 10.84 14 11.14 14 11.5067V13.8333C14 14.2 13.7 14.5 13.3333 14.5C7.07333 14.5 2 9.42667 2 3.16667C2 2.8 2.3 2.5 2.66667 2.5H5C5.36667 2.5 5.66667 2.8 5.66667 3.16667C5.66667 4 5.8 4.8 6.04667 5.54667C6.12 5.78 6.06667 6.04 5.88 6.22667L4.41333 7.69333Z' fill='#5C5858' />
        </svg>

    );
};
